import type { CountryCode } from 'libphonenumber-js/max';
import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { REGEX_PHONE_BASIC_ALLOWED, REGEX_PHONE_PLUS, REGEX_PHONE_ONLY_PLUS, REGEX_PHONE_SEPARATORS } from '../constants/regex';

export function validateMobile(number: string, defaultCountry = 'GB') {
	const value = number.trim();

	if (REGEX_PHONE_BASIC_ALLOWED.test(value)) {
		return { valid: false, reason: 'invalid-characters' };
	}

	if ((value.match(REGEX_PHONE_PLUS) || []).length > 1) {
		return { valid: false, reason: 'multiple-plus' };
	}

	if (value.includes('+') && !value.startsWith('+')) {
		return { valid: false, reason: 'plus-not-at-start' };
	}

	if (REGEX_PHONE_ONLY_PLUS.test(value)) {
		return { valid: false, reason: 'invalid-plus-sequence' };
	}

	// Without a leading 0 or +, the number gets saved as typed and SMS can't reach it.
	const compact = value.replace(REGEX_PHONE_SEPARATORS, '');

	if (!compact.startsWith('0') && !compact.startsWith('+')) {
		return { valid: false, reason: 'missing-prefix' };
	}

	const phone = value.startsWith('+')
		? parsePhoneNumberFromString(value)
		: parsePhoneNumberFromString(value, defaultCountry as CountryCode);

	if (!phone || !phone.isValid()) {
		return { valid: false, reason: 'invalid-number' };
	}

	const type = phone.getType?.();
	const isMobileLike
		= !type || type === 'MOBILE' || type === 'FIXED_LINE_OR_MOBILE';

	return {
		valid: isMobileLike,
		e164: phone.number,
		country: phone.country,
		type,
	};
}
